/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  MenuItem,
  Chip,
  DialogContent,
  Container,
} from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { LocationOn } from '@mui/icons-material';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import axios from '../../../utils/axios';
import sea2 from '../../../media/Images/sea2.jpg';
import seaicon from '../../../media/Images/seaicon.png';
import airicon1 from '../../../media/Images/air-icon-1.png';
import airicon2 from '../../../media/Images/air-icon-3.png';
import air from '../../../media/Images/air3.jpg';
import air2 from '../../../media/Images/2.jpg';
import '../../stylemod.css';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';
import ComplaintAdd from '../Common/ComplaintAdd';

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

const statusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Cancelled Request', value: 'Cancelled Request' },
  { label: 'Booking Confirmed', value: 'Booking Confirmed' },
  { label: 'Bill Raised', value: 'Bill Raised' },
  { label: 'Payment Received', value: 'Payment Received' },
  { label: 'Part. Payment', value: 'Part. Payment' },
];

const typeOptions = [
  { label: 'Air-Cargo', value: 'courier' },
  { label: 'Sea-Cargo', value: 'cargo' },
];

const CustomerComplaintReview = () => {
  const navigate = useNavigate();
  const [getDataForView, setGetDataForView] = useState([]);
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterInputs, setFilterInputs] = useState({
    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    status: 'All',
    type: sessionStorage.getItem('Origin') === 'UK' ? 'cargo' : 'courier',
  });

  const origin = sessionStorage.getItem('Origin') || 'IN'; // Default to IN if not set
  const [isComplaintDialogOpen, setComplaintDialogOpenState] = useState(false);
  const [complaintDetail, setComplaintDetail] = useState({
    courierCargoId: '',
    shipmentType: '',
    userType: 'Customer',
    complaintId: '',
    bookingOrderId: 0,
    Register: 'N',
  });

  const closeComplaintDialog = () => {
    setComplaintDialogOpenState(false);
  };

  const openComplaintDialog = (data) => {
    setComplaintDetail(prev => ({
      ...prev,
      courierCargoId: filterInputs.type === 'courier' ? data.courier_Id : data.cargo_Id,
      shipmentType: data.shipment_Type,
      complaintId: data.complaintId,
      bookingOrderId: data.BookOrderId,
      Register: data.Register,
    }));
    setComplaintDialogOpenState(true);
  };


  async function getAllData() {

    if (!validateDateInputs(filterInputs)) {
      return; // Stop the request if date validation fails
    }

    try {
      showLoading();
      const branchId = 0;
      const companyId = sessionStorage.getItem('CompanyId');
      let response;
      if (filterInputs.type === 'courier') {
        response = await axios.get(
          `Transactions/Courier/GetCourierCollection/${moment(filterInputs.fromDate).format('YYYYMMDD')}/${moment(
            filterInputs.toDate
          ).format('YYYYMMDD')}/${filterInputs.status}/${companyId}/${branchId}/${sessionStorage.getItem('UserId')}/N`
        );
      } else if (filterInputs.type === 'cargo') {
        response = await axios.get(
          `Transactions/Cargo/GetAllCargoCollection/${moment(filterInputs.fromDate).format('YYYYMMDD')}/${moment(
            filterInputs.toDate
          ).format('YYYYMMDD')}/${filterInputs.status}/${companyId}/${branchId}/${sessionStorage.getItem('UserId')}/N`
        );
      } else {
        throw new Error('Invalid type selected. Please choose a valid type.');
      }

      setGetDataForView(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  useEffect(() => {
    getAllData();
  }, []);

  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);


  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const validateDateInputs = (inputs) => {
    const errors = {};

    // Validate fromDate
    if (!inputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(inputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate
    if (!inputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(inputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFilterInputs = (e) => {
    const { name, value } = e.target;

    // Early exit for 'type' field if user cancels confirmation
    if (name === 'type') {
      const isConfirmed = window.confirm("Do you want to clear the grid?");
      if (!isConfirmed) return; // Exit if canceled
      setFilterInputs({ ...filterInputs, [name]: value });
      setGetDataForView([]);
      return; // Explicit exit after handling
    }

    // Default behavior for other fields
    setFilterInputs({ ...filterInputs, [name]: value });

    // Validate date fields
    if (name === 'fromDate' || name === 'toDate') {
      validateDateInputs({ ...filterInputs, [name]: value });
    }
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={0.5}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={12}
            pl={2}
            color="white"
            sx={{
              background: '#8ABFA3',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Complaints Review
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} p={1} my={0.5} rowSpacing={2} columnSpacing={1}>
          <Grid item md={4} xs={12}>
            {/* Status Filter */}
            <TextField
              fullWidth
              select
              label="Status"
              name="status"
              value={filterInputs.status}
              onChange={handleFilterInputs}
              variant="outlined"
              size="small"
              error={!!formErrors.status}
              helperText={formErrors.status}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={3} xs={12}>
            {/* Status Filter */}
            <TextField
              fullWidth
              select
              label="Shipment Type"
              name="type"
              value={filterInputs.type}
              onChange={handleFilterInputs}
              variant="outlined"
              size="small"
              error={!!formErrors.type}
              helperText={formErrors.type}
            >
              <MenuItem key="courier" value="courier">
                Air-Cargo
              </MenuItem>
              {sessionStorage.getItem('Origin') === 'UK' && (
                <MenuItem key="cargo" value="cargo">
                  Sea-Cargo
                </MenuItem>
              )}
            </TextField>
          </Grid>

          <Grid item md={2} xs={12}>
            {/* From Date */}
            <TextField
              fullWidth
              label="From Date"
              type="date"
              name="fromDate"
              value={filterInputs.fromDate}
              onChange={handleFilterInputs}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              error={!!formErrors.fromDate}
              helperText={formErrors.fromDate}
              inputProps={{ max: '9999-12-31' }}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            {/* To Date */}
            <TextField
              fullWidth
              label="To Date"
              type="date"
              name="toDate"
              value={filterInputs.toDate}
              onChange={handleFilterInputs}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              error={!!formErrors.toDate}
              helperText={formErrors.toDate}
              inputProps={{ max: '9999-12-31' }}
            />
          </Grid>

          <Grid item md={1} xs={12}>
            {/* View Button */}
            <Button variant="contained" color="success" onClick={getAllData} fullWidth>
              View
            </Button>
          </Grid>
        </Grid>
        {getDataForView.length > 0 ? (
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    {filterInputs.type === 'courier' ? (
                      <StyledTableCell align="left">Courier Ref No</StyledTableCell>
                    ) : (
                      <StyledTableCell align="left">Cargo Ref No</StyledTableCell>
                    )}

                    {filterInputs.type === 'courier' ? (
                      <StyledTableCell align="left">Courier Date</StyledTableCell>
                    ) : (
                      <StyledTableCell align="left">&nbsp;Cargo Date&nbsp;</StyledTableCell>
                    )}
                    <StyledTableCell align="center">Customer</StyledTableCell>
                    <StyledTableCell align="left">From</StyledTableCell>
                    <StyledTableCell align="left">To</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                    <StyledTableCell align="center">No of Boxes</StyledTableCell>
                    <StyledTableCell align="center">Parcel Weight</StyledTableCell>
                    <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                      Actions
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : getDataForView
                  ).map((data, i) => (
                    <>
                      <TableRow key={data.CUSTOMERID} hover>
                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>

                        {filterInputs.type === 'courier' ? (
                          <TableCell align="center">{data.COURIER_NO}</TableCell>
                        ) : (
                          <TableCell align="center">{data.cargo_No}</TableCell>
                        )}
                        {filterInputs.type === 'courier' ? (
                          <TableCell align="center">
                            {moment(data.courierDate, 'DD/MM/YYYY')?.format('DD-MM-YYYY') || '-'}
                          </TableCell>
                        ) : (
                          <TableCell align="center">
                            {moment(data.cargoDate, 'DD/MM/YYYY')?.format('DD-MM-YYYY') || '-'}
                          </TableCell>
                        )}
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {data.CUSTOMERNAME || '-'}
                        </TableCell>

                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PersonPinIcon fontSize="x-small" color="primary" />
                              <Typography variant="subtitle2" color="#243642" pr={1}>
                                {data.SENDER_NAME}
                              </Typography>{' '}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <LocationOn fontSize="x-small" color="error" />
                              <Typography variant="body2">
                                {data.SENDER_CITY}, {data.SENDER_STATE}, <br />
                                {data.SENDER_COUNTRY}, {data.SENDER_PINCODE}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PersonPinIcon fontSize="x-small" color="primary" />
                              <Typography variant="subtitle2" color="#243642" pr={1}>
                                {data.RECEIVER_NAME}
                              </Typography>{' '}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <LocationOn fontSize="x-small" color="error" />
                              <Typography variant="body2">
                                {data.RECEIVER_CITY}, {data.RECEIVER_STATE}, <br />
                                {data.RECEIVER_COUNTRY}, {data.RECEIVER_PINCODE}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                          {data.singleOrderStatus === 'Cancelled' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="error" />
                          ) : data.singleOrderStatus === 'Bill Raised' ||
                            data.singleOrderStatus === 'Payment Received' ||
                            data.singleOrderStatus === 'Booking Confirmed' ||
                            data.singleOrderStatus === 'Part Payment' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="info" />
                          ) : data.singleOrderStatus === 'Approved' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="success" />
                          ) : data.singleOrderStatus === 'Cancel Requested' ? (
                            <Chip label={data.singleOrderStatus} size="small" variant="outlined" color="error" />
                          ) : (
                            <Chip label={data.singleOrderStatus} size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                          {data.NO_OF_BOXES || '-'}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                          {data.ParcelWeight || '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ position: 'sticky', right: 0, bgcolor: '#F9FAFB', zIndex: 1, whiteSpace: 'nowrap' }}
                        >
                          <Stack
                            direction="column"
                            spacing={1}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ width: '100%' }}
                          >
                            <Chip
                              icon={<RemoveRedEyeIcon />}
                              size="small"
                              label='Preview'
                              color='primary'
                              variant='contained'
                              sx={{ width: '100%' }}
                              onClick={() => {
                                if (filterInputs.type === 'courier') {
                                  navigate(`/dashboard/manage/courier_order_creation/Edit/${data.courier_Id}/A`);
                                } else {
                                  navigate(`/dashboard/manage/cargo_order_creation/Edit/${data.cargo_Id}/A`);
                                }
                              }}
                            />
                            {Number(data.ManifestId) !== 0 &&
                              <>
                                <Chip
                                  variant={Number(data.complaintId) === 0 ? 'contained' : 'outlined'}
                                  icon={<ReportGmailerrorredIcon fontSize='small' />}
                                  label={Number(data.complaintId) === 0 ? 'Register Complaint' : 'View Complaint'}
                                  color="error"
                                  size="small"
                                  sx={{ width: '100%' }}
                                  onClick={() => {
                                    openComplaintDialog(data)
                                  }}
                                />
                              </>
                            }
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        ) : (
          <NoResultsFound />
        )}

        {/* Add Complaint Popup */}
        <Dialog fullWidth maxWidth={'md'} open={isComplaintDialogOpen} onClose={closeComplaintDialog}>
          <DialogContent>
            <ComplaintAdd
              setComplaintDialogOpenState={setComplaintDialogOpenState}
              complaintDetail={complaintDetail}
              getAllData={getAllData}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default CustomerComplaintReview;
